const getHTMLInputElementCaretPosition = (
  element: HTMLInputElement
): [number, number] | undefined => {
  if (!element) {
    return
  }

  return [element.selectionStart || 0, element.selectionEnd || 0]
}

export default getHTMLInputElementCaretPosition
